// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';
import Truncate from 'react-truncate';
// COMPONENTS
import Button from 'components/common/Button';
import Popover from 'components/common/Popover';
import styled from 'styled-components';
// ANTD
import Table from 'antd/lib/table';
import Icon from 'antd/lib/icon';
// APOLLO
import { graphql, compose } from 'react-apollo';
import lineItemFragment from 'ApolloClient/Fragments/lineItemFragment';
import lineItemsQuery from 'ApolloClient/Queries/lineItems';
import disableLineItem from 'ApolloClient/Mutations/disableLineItem';
// LIB
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

// COMPONENTS
// import DeleteButton from '../../../components/buttons/DeleteButton';

const StyledButton = styled.button`
  background: transparent;
  border: 0px;
  display: block;
  font-family: ${p => p.theme.fontFamily};
  margin: 10px;

  :focus {
    outline: 0;
  }

  :hover {
    color: ${p => p.theme.color.primary};
    cursor: pointer;
  }
`

export const LineItemsTable = ({ data, onEdit, disableLineItem }) => {
  const { error, loading, lineItems } = data;

  if (error) {
    console.log(error);
    return <span>Something went wrong :(</span>;
  }

  if (loading) {
    return (
      <div>
        <h2 className="center">Loading...</h2>
      </div>
    );
  }

  const onDelete = async (_id) => {
    await disableLineItem({ variables: { _id } });
    window.location.reload();
  }

  const columns = [
    {
      title: 'TITLE',
      dataIndex: 'title',
      key: 'title',
      width: 75,
    },
    {
      title: 'DESCRIPTION',
      dataIndex: 'description',
      key: 'description',
      width: 75,
      render: (text, lineItem) => (
        <Truncate lines={2} ellipsis={<span>...</span>}>
          {(lineItem && lineItem.description) || ''}
        </Truncate>
      ),
    },
    {
      title: 'AMOUNT',
      dataIndex: 'amount',
      key: 'amount',
      width: 75,
      render: (text, lineItem) => {
        let currencySymbol = CurrencyHelpers.getCurrencySymbol(lineItem.currency);
        return <div style={{ color: '#2ecc71'}}>{CurrencyHelpers.centsToDollars(lineItem.amount, { symbol: currencySymbol })}</div>;
      },
    },
    {
      title: 'ACTIONS',
      width: 50,
      render: (text, record) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Popover 
              placement="right"
              content={
                <div>
                  <StyledButton onClick={() => onEdit(record)}>Edit</StyledButton>
                  <StyledButton onClick={() => onDelete(record._id)}>Delete</StyledButton>
                </div>
              }
              title={null}
            >
              <Icon type="ellipsis" />
            </Popover>
          </div>
        )
        return (
          <Button
            type="dashed"
            onClick={() =>
              // Pass data up to parent component
              onEdit(record)
            }
          >
            <Icon type="edit" />
          </Button>
        );
      }
    },
    // {
    //   title: 'DELETE',
    //   width: 50,
    //   render: (text, record) => (
    //     <DeleteButton id={record._id} record={record} itemType="Line Item" deleteFunc="deleteLineItem" />
    //   ),
    // },
  ];

  return (
    <Table
      rowKey={record => record._id}
      columns={columns}
      dataSource={lineItems}
      pagination={{
        pageSize: 5,
      }}
    />
  );
};

LineItemsTable.propTypes = {
  data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    lineItems: PropTypes.arrayOf(propType(lineItemFragment)),
  }).isRequired,
  onEdit: PropTypes.func,
};

LineItemsTable.defaultProps = {
  onEdit: () => {},
};

export default compose(
  graphql(lineItemsQuery),
  graphql(disableLineItem, { name: 'disableLineItem'})
)(LineItemsTable);



// WEBPACK FOOTER //
// ./src/routes/app-studio/PricingAndPackagingArea/LineItemsTable/index.js